import { ref, watch } from 'vue';
import { useRoute } from 'vue-router';
import { isNotOnPublicPage } from '@/utils/http';
import { updateIntercomTheme } from '@/utils/intercom';

const isPendoDarkMode = ref(false);
const isSystemDarkMode = ref(false);
const darkModeInLocalStorage = ref(null);

export default function useDarkMode () {
    const route = useRoute();

    const setDarkMode = (value) => {
        window.localStorage.setItem('dark-mode', JSON.stringify(value));
        darkModeInLocalStorage.value = value;

        let isDarkMode = value;

        switch (value) {
            case 'system':
                isDarkMode = isSystemDarkMode.value;
                if (isDarkMode) {
                    document.documentElement.setAttribute('data-theme', 'dark');
                } else {
                    document.documentElement.removeAttribute('data-theme');
                }
                break;
            case true:
                document.documentElement.setAttribute('data-theme', 'dark');
                break;
            default:
                document.documentElement.removeAttribute('data-theme');
                isDarkMode = false;
                break;
        }

        isPendoDarkMode.value = isDarkMode;
        updateIntercomTheme(isDarkMode);
    };

    const initializeDarkMode = () => {
        const setupDarkMode = () => {
        // get dark mode from system preferences and watch for changes
            if (window.matchMedia) {
                isSystemDarkMode.value = window.matchMedia('(prefers-color-scheme: dark)').matches;

                window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', (event) => {
                    isSystemDarkMode.value = event.matches;

                    if (darkModeInLocalStorage.value === 'system') {
                        setDarkMode('system');
                    }
                });
            }

            const darkMode = JSON.parse(window.localStorage.getItem('dark-mode') || 'false');

            darkModeInLocalStorage.value = darkMode;

            setDarkMode(darkModeInLocalStorage.value);
        };

        if (isNotOnPublicPage()) {
            setupDarkMode();
        } else {
            const unwatch = watch(() => route.path, (newPath) => {
                if (newPath && isNotOnPublicPage()) {
                    unwatch();
                    setupDarkMode();
                }
            });
        }
    };

    return {
        isPendoDarkMode,
        isSystemDarkMode,
        darkModeInLocalStorage,
        setDarkMode,
        initializeDarkMode,
    };
}
